import Country from "../../slices/master/country/Country"
import State from "../../slices/master/state/State"
import City from "../../slices/master/city/City"
import ChargesType from "../../slices/master/chargesType/ChargesType"
import Charges from "../../slices/master/charges/Charges"
import Checklist from "../../slices/master/checklist/Checklist"
import ServiceType from "../../slices/master/serviceType/ServiceType"
import ServiceSubType from "../../slices/master/serviceSubType/ServiceSubType"
import DeliveryPartner from "../../slices/master/deliveryPartner/DeliveryPartner"
import ExpenseType from "../../slices/master/expenseType/ExpenseType"
import NoticeType from "../../slices/master/noticeType/NoticeType"

const masterReducer = {
    country: Country,
    state: State,
    city: City,
    chargesType: ChargesType,
    charges: Charges,
    checklist: Checklist,
    serviceType: ServiceType,
    serviceSubType: ServiceSubType,
    deliveryPartner: DeliveryPartner,
    expenseType: ExpenseType,
    noticeType: NoticeType,
};

export default masterReducer;